import {Button, Form, Input} from "antd"
import {ArrowRight, Trash2} from "lucide-react"
import {images} from "../../../constants";
import {useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import Localization from "../../../components/Localizations/Localization";
import {useTranslation} from "react-i18next";

const DeviceReregistrationFirstForm = ({handleClear, uploadProps}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [form] = Form.useForm();

    useEffect(() => {
        const savedData = localStorage.getItem("deviceReRegistrationStep1");
        if (savedData) {
            form.setFieldsValue(JSON.parse(savedData));
        }
    }, [form]);

    const handleNext = async () => {
        try {
            await form.validateFields(); // Validate Step 1 fields
            const formData = form.getFieldsValue(); // Get form data

            // Save Step 1 data to localStorage
            localStorage.setItem("deviceReRegistrationStep1", JSON.stringify(formData));
            console.log(formData);

            // Navigate to Step 2
            navigate("/device/re/registration/step/2");
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };

    return (
        <div className="device-registration-container">
            <div className="banner">
                <div className="banner-logo">
                    <img src={images.deviceRegistrationBanner} alt="fiscalBOX"/>
                </div>
                <div className="banner-text">
                    <h1>{t("pages.devices.reRegistrationForm.title")}</h1>
                    <p>{t("pages.devices.reRegistrationForm.description")}</p>
                </div>
            </div>

            <div className="navigation-bar">
                <div>
                    <Localization/>
                </div>
                <div className="step-indicator">
                    <span className="step active">{t("pages.devices.registrationForm.steps.step1")}</span>
                    <span className="step-divider"></span>
                    <span className="step" onClick={handleNext}>{t("pages.devices.registrationForm.steps.step2")}</span>
                </div>
            </div>

            <div className="form-title">
                <h2>{t("pages.devices.registrationForm.form1.title")}</h2>
                <p>{t("pages.devices.registrationForm.form1.description")}</p>
            </div>

            <Form form={form} layout="vertical" className="registration-form">
                <Form.Item label={t("pages.devices.registrationForm.form1.field1.label")} name="email"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field1.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.reRegistrationForm.form1.field1.label")} name="deviceSerial"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.reRegistrationForm.form1.field1.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.reRegistrationForm.form1.field2.label")} name="terminalId"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.reRegistrationForm.form1.field2.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field6.label")} name="marketName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field6.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field4.label")} name="inn"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field4.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.reRegistrationForm.form1.field3.label")} name="currentMarketName"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.reRegistrationForm.form1.field3.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field9.label")} name="marketCity"
                           rules={[{
                               required: false,
                               message: t("pages.devices.registrationForm.common.error.error1")
                           }]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field9.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field10.label")} name="marketDistrict"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input label={t("pages.devices.registrationForm.form1.field10.placeholder")}/>
                </Form.Item>

                <Form.Item label={t("pages.devices.registrationForm.form1.field11.label")} name="marketStreet"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form1.field11.placeholder")}/>
                </Form.Item>

                <div className="button-container">
                    <Button icon={<ArrowRight size={16}/>} type="primary" onClick={() => handleNext(form)}
                            className="next-button">
                        {t("pages.devices.registrationForm.buttons.button3")}
                    </Button>
                    <Button icon={<Trash2 size={16}/>} type="dashed" danger onClick={() => handleClear(form)}
                            className="clear-button">
                        {t("pages.devices.registrationForm.buttons.button4")}
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default DeviceReregistrationFirstForm;
